/**
 * Quick Add dropdown menu — the header-bar entry point for adding
 * items that don't yet live in the product catalog (Custom Item) or
 * for opening the category-specific Quick Add dialogs (Laminate,
 * Highlighter, Hardware, Adhesive, Veneer).
 *
 * Extracted from ProductsPage.js — 56 LOC of pure
 * JSX with no internal state. Every action lives on the caller as a
 * callback so this stays trivial to test + reuse.
 */
import React from 'react';
import { Button } from '../../../components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../../../components/ui/dropdown-menu';
import { Zap, ChevronDown, Palette, Sparkles, Wrench, Pipette, TreePine } from 'lucide-react';


export function QuickAddMenu({
  onCustomItem,
  onAddLaminate,
  onAddHighlighter,
  onAddHardware,
  onAddAdhesive,
  onAddVeneer,
}) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          size="sm"
          className="border-[#DAA520] text-[#8B6914] hover:bg-[#DAA520]/10 text-xs sm:text-sm h-9"
          data-testid="quick-add-menu-btn"
        >
          <Zap className="w-3 h-3 sm:w-4 sm:h-4 mr-1" /> Quick Add <ChevronDown className="w-3 h-3 ml-1" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuLabel className="text-xs text-[#8F9485]">Add to Quotation Only</DropdownMenuLabel>
        <DropdownMenuItem onClick={onCustomItem} className="cursor-pointer" data-testid="quick-add-custom-item">
          <Zap className="w-4 h-4 mr-2 text-[#DAA520]" />
          <span>Custom Item</span>
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuLabel className="text-xs text-[#8F9485]">Save &amp; Remember</DropdownMenuLabel>
        <DropdownMenuItem onClick={onAddLaminate} className="cursor-pointer" data-testid="quick-add-laminate">
          <Palette className="w-4 h-4 mr-2 text-[#1976D2]" />
          <span>Add Laminate</span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={onAddHighlighter} className="cursor-pointer" data-testid="quick-add-highlighter">
          <Sparkles className="w-4 h-4 mr-2 text-[#9C27B0]" />
          <span>Add Highlighter</span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={onAddHardware} className="cursor-pointer" data-testid="quick-add-hardware">
          <Wrench className="w-4 h-4 mr-2 text-[#4A5568]" />
          <span>Add Hardware</span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={onAddAdhesive} className="cursor-pointer" data-testid="quick-add-adhesive">
          <Pipette className="w-4 h-4 mr-2 text-[#9B4DCA]" />
          <span>Add Adhesive</span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={onAddVeneer} className="cursor-pointer" data-testid="quick-add-veneer">
          <TreePine className="w-4 h-4 mr-2 text-[#8B4513]" />
          <span>Add Veneer</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
